import {UserPreferencesData} from "@feature/user-preferences/models/user-preferences-data";
import {IPeriodicEmailSettings} from "./periodic-email-settings";

export class ChangeTrackedValue<T> {

  original: T
  current: T

  constructor(initial: T = null) {
    this.original = initial
    this.current = initial
  }

  changed(): boolean {
    return this.current !== this.original
  }
}

export interface DropDownItem {
  label: string,
  value: any
}

export interface ISettingDescriptor {
  controlId: string
  controlLabelText: string
  value: ChangeTrackedValue<any>
  disabled: boolean
  hidden: boolean
}

export interface IDropDownSettingDescriptor extends ISettingDescriptor {
  options: DropDownItem[],
}

export interface IApiResponseData {
  SystemDefaults: UserPreferencesData
  UserPreferences: UserPreferencesData
}

export interface IPeriodicEmailSettingsTuple {
  SystemDefaults: IPeriodicEmailSettings
  UserPreferences: IPeriodicEmailSettings
}

export interface ISettingsPresentation {
  SendEmailOnFormAssignment: IDropDownSettingDescriptor,
  DisplayNonCurrentManagers: IDropDownSettingDescriptor,
  SkipListerPage: IDropDownSettingDescriptor,
  DisplayObsoleteUnits: IDropDownSettingDescriptor,
  PeriodicEmailSettingsTuple: IPeriodicEmailSettingsTuple,
  DisplayNonCurrentLeasesAndTenants: IDropDownSettingDescriptor,
  DisplayNonCurrentHeadLeasesAndLandlords: IDropDownSettingDescriptor
}
